const ACTION = {
    UPDATE_REGISTRATION_TIME: 'UPDATE_REGISTRATION_TIME',
    UPDATE_REGISTRATION_TIME_ERROR_TEXT: 'UPDATE_REGISTRATION_TIME_ERROR_TEXT',
}

export default ACTION;
